import { Controller } from "@hotwired/stimulus"

// Scroll-to-top button. Attach to the button (#myBtn classic / the tw floating button).
// Classic pages scroll the window; the new UI scrolls inside <main data-scroll-top-container>
// (the window never moves), so the controller binds to that container when present and
// falls back to the window otherwise.
export default class extends Controller {
  connect() {
    this.container = document.querySelector("[data-scroll-top-container]")
    this.scrollTarget = this.container || window
    this.boundScroll = this.onScroll.bind(this)
    this.scrollTarget.addEventListener("scroll", this.boundScroll)
    this.onScroll()
  }

  disconnect() {
    this.scrollTarget.removeEventListener("scroll", this.boundScroll)
  }

  scrolled() {
    if (this.container) return this.container.scrollTop
    return document.body.scrollTop || document.documentElement.scrollTop
  }

  onScroll() {
    this.element.style.display = this.scrolled() > 200 ? "block" : "none"
  }

  scrollToTop() {
    const target = this.container || document.documentElement
    target.scrollTo({ top: 0, behavior: "smooth" })
    if (!this.container) document.body.scrollTop = 0
  }
}
